import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { trpc } from '@/lib/trpc';
import { Header } from './-components/header';
import { Footer } from './-components/footer';
import { Layout } from './-components/layout';
import { ContactInfo } from './-components/contact/info';
import { ContactPanel, type Audience } from './-components/contact/panel';

export const Route = createFileRoute('/new/contact')({
	loader: ({ context }) => {
		// Warms the partner-NGO logos in the left column. `prefetchQuery`, not `ensureQueryData` — see
		// the homepage loader for why a floating rejected promise here takes the server process down.
		context.queryClient.prefetchQuery(trpc.portal.getWorldcooGlobalStats.queryOptions());
	},
	component: Component,
});

function Component() {
	// Both owned here because both drive BOTH columns. The audience picked on the right decides which
	// logos the strip on the left shows; sending swaps the panel for its confirmation and sets the
	// mailbox in the address card drawing. Neither column can see the other's state.
	const [audience, setAudience] = useState<Audience | null>(null);
	const [sent, setSent] = useState(false);

	return (
		<Layout>
			<Header />
			{/* The hand-off's own 793:559 at 1440, with its 24px gutter. `items-start`, NOT stretch: the
			    panel grows by a lot once a company fills the questionnaire in, and stretching made the
			    left column's photograph grow with it. Both columns still end together in the state the
			    hand-off actually draws, because their designed heights both come to 801. */}
			<section className="mx-auto grid max-w-[1440px] items-start gap-6 px-6 pt-4 pb-16 md:pb-24 lg:grid-cols-[793fr_559fr] xl:px-8">
				<ContactInfo audience={audience} sent={sent} />
				<ContactPanel audience={audience} onAudienceChange={setAudience} sent={sent} onSent={() => setSent(true)} />
			</section>
			{/* `links`, not `form`: a second contact form directly under this one would be absurd. */}
			<Footer />
		</Layout>
	);
}
